import { useState } from "react"
import type { RelaySet } from "@/nostr/types"
import { simplifyUrl } from "@/utils/url"
import { RelayIcon } from "./Avatar"
import { Icon } from "./Icon"

export interface RelaySetCardProps {
  set: RelaySet
  active?: boolean
  onSelect: () => void
  onEdit?: () => void
}

/** A relay set: the "relay feed" grouping at the heart of the client. */
export function RelaySetCard({ set, active, onSelect, onEdit }: RelaySetCardProps) {
  const [expanded, setExpanded] = useState(false)

  return (
    <div className={`relay-set-card ${active ? "relay-set-active" : ""}`}>
      <div className="relay-set-head">
        <button type="button" className="relay-set-main" onClick={onSelect}>
          <span className="relay-set-icon">
            <Icon name="relay" size={18} />
          </span>
          <span className="relay-set-name">
            {set.name}
            {set.preset && <span className="badge">preset</span>}
          </span>
          <span className="relay-set-count">{set.relayUrls.length}</span>
        </button>
        <div className="relay-set-tools">
          <button
            type="button"
            className="icon-button small"
            aria-expanded={expanded}
            aria-label={expanded ? "Hide relays" : "Show relays"}
            onClick={() => setExpanded((value) => !value)}
          >
            <Icon name="chevron-down" size={14} className={expanded ? "rotated" : ""} />
          </button>
          {onEdit && !set.preset && (
            <button type="button" className="icon-button small" aria-label="Edit relay set" onClick={onEdit}>
              <Icon name="pencil" size={14} />
            </button>
          )}
        </div>
      </div>
      {expanded && (
        <ul className="relay-set-relays">
          {set.relayUrls.length === 0 && <li className="muted small">This set has no relays yet.</li>}
          {set.relayUrls.map((url) => (
            <li key={url}>
              <RelayIcon url={url} size={16} />
              <span>{simplifyUrl(url)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
